import { AuxiliaryData } from '../util/LiDAR/AuxiliaryInterface';
import * as marietta from '../../index';
import { ITEM_MODE_NO } from '../Constants';
import AuxiliaryConstructionCollection from '../collection/AuxiliaryConstructionCollection';
import { ExtrasType } from '../../view3d/webcad/WebCadDefines';
import { PinDialogUtil } from '../../view3d/webcad/util/PinDialogUtil';
import { MonicaObject } from '../item';

export class AuxiliaryUtil {

  /** 部屋を特定できなかった付帯工事に入れる部屋名 */
  private static readonly ROOM_NAME_WHOLE = '全体';

  /**
   * 指定アイテムに紐づく付帯工事ピンが持つ部屋名。複数のピンが紐づく場合は最後に紐づけたものを正とする。
   * 紐づくピンがない場合と部屋を特定できていない（'全体'）場合は null を返す。
   */
  static getRoomNameByIntersectUid(uid: string): string | null {
    if (!uid) return null;
    const pin: marietta.webcad.item.FreeText[] = <marietta.webcad.item.FreeText[]>marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_FREETEXT_NO);
    let latestRoomName: string = null;
    let latestLinkedAt: number = 0;
    for (let i: number = 0; i < pin.length; i++) {
      if (pin[i].itemInfo?.intersectItem?.uid !== uid) continue;
      const roomName = pin[i].itemInfo?.auxiliaryData?.auxiliaryDatum?.room_name;
      if (!roomName || roomName === AuxiliaryUtil.ROOM_NAME_WHOLE) continue;
      // linkedAt がない既存データ・自動紐づけは最古扱い。同時刻はリスト順で先勝ち
      const linkedAt = pin[i].itemInfo.intersectItem.linkedAt ?? 0;
      if (latestRoomName !== null && linkedAt <= latestLinkedAt) continue;
      latestRoomName = roomName;
      latestLinkedAt = linkedAt;
    }
    return latestRoomName;
  }

  /**
   * 付帯工事一覧の取得
   * @param uuid
   */
  static getAuxiliaryList(): AuxiliaryConstructionCollection[] {
    let pin: marietta.webcad.item.FreeText[] = <marietta.webcad.item.FreeText[]>marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_FREETEXT_NO);
    let retList: AuxiliaryConstructionCollection[] = [];

    for (let i: number = 0; i < pin.length; i++) {
      if (pin[i].itemInfo?.auxiliaryData) {
        const target: AuxiliaryData = pin[i].itemInfo?.auxiliaryData;
        const retData: AuxiliaryConstructionCollection = new AuxiliaryConstructionCollection();
        retData.id = target.auxiliaryDatum.constructionId;
        retData.guid = pin[i].itemInfo.guid;
        retData.auxiliary_construction_name = target.auxiliaryDatum.construction;
        retData.note = target.auxiliaryDatum.remarks;
        retData.quantity = target.auxiliaryDatum.quantity;
        retData.unit = target.auxiliaryDatum.unit;
        retData.unit_price = target.auxiliaryDatum.unitPrice;
        retData.total_price = target.auxiliaryDatum.totalPrice;
        retData.debtor_burden_rate = target.auxiliaryDatum.rate;
        retData.repair_reason = target.auxiliaryDatum.repair;
        retData.other_flag = Boolean(target.auxiliaryDatum.other_flag);
        retData.other_text = target.auxiliaryDatum.otherText;
        retData.estimatedEntryFlg = target.auxiliaryDatum.estimatedEntryFlg;
        retData.intersectItem = pin[i].itemInfo?.intersectItem;
        retData.parentPin = pin[i];
        //nullの場合は、紐づけアイテムの場所
        if( target.auxiliaryDatum.room_name == null ){
          const intersectItem = pin[i].itemInfo?.intersectItem;
          const intersectItemInfo = PinDialogUtil.getCurrentItem(intersectItem?.uid);
          const iteminfo = intersectItemInfo instanceof MonicaObject ? intersectItemInfo.itemInfo : intersectItemInfo?.parentObj?.itemInfo;
          pin[i].itemInfo.auxiliaryData.auxiliaryDatum.room_name = pin[i].itemInfo?.intersectItem?PinDialogUtil.getItemRoomName( iteminfo, intersectItem, pin[i].itemInfo) :null;
        }
        if( target.auxiliaryDatum.room_name == '' ){
          target.auxiliaryDatum.room_name = AuxiliaryUtil.ROOM_NAME_WHOLE;
        }

        retData.room_name = target.auxiliaryDatum.room_name;

        retList.push(retData);
      }
    }
    return retList;
  }


  /**
   * 付帯工事一覧の取得
   * @param uuid
   */
  static getAuxiliaryListForQuoteById(uuid: string): AuxiliaryConstructionCollection[] {
    let pin: marietta.webcad.item.FreeText[] = <marietta.webcad.item.FreeText[]>marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_FREETEXT_NO);
    let retList: AuxiliaryConstructionCollection[] = [];
    const isFloor: boolean = Boolean(0 < uuid.indexOf('_floor'));
    const isCeiling: boolean = Boolean(0 < uuid.indexOf('_ceiling'));

    for (let i: number = 0; i < pin.length; i++) {
      if (pin[i].itemInfo?.auxiliaryData) {
        let isMismatch: Boolean = false;
        if (isFloor && !(pin[i].itemInfo?.intersectItem?.type == ExtrasType.FLOOR)) isMismatch = true;
        if (isCeiling && !(pin[i].itemInfo?.intersectItem?.type == ExtrasType.CEILING)) isMismatch = true;
        if (isMismatch == false && 0 <= uuid.indexOf(pin[i].itemInfo?.intersectItem?.uid)) {
          const target: AuxiliaryData = pin[i].itemInfo?.auxiliaryData;
          const retData: AuxiliaryConstructionCollection = new AuxiliaryConstructionCollection();
          retData.guid = pin[i].itemInfo.guid;
          retData.id = target.auxiliaryDatum.constructionId;
          retData.auxiliary_construction_name = target.auxiliaryDatum.construction;
          retData.note = target.auxiliaryDatum.remarks;
          retData.quantity = target.auxiliaryDatum.quantity;
          retData.unit = target.auxiliaryDatum.unit;
          retData.unit_price = target.auxiliaryDatum.unitPrice;
          retData.total_price = target.auxiliaryDatum.totalPrice;
          retData.debtor_burden_rate = target.auxiliaryDatum.rate;
          retData.repair_reason = target.auxiliaryDatum.repair;
          retData.other_flag = Boolean(target.auxiliaryDatum.other_flag);
          retData.other_text = target.auxiliaryDatum.otherText;
          retData.estimatedEntryFlg = target.auxiliaryDatum.estimatedEntryFlg;
          retData.intersectItem = pin[i].itemInfo?.intersectItem;

          //部屋名の整理
          const intersectItem = pin[i].itemInfo?.intersectItem;
          const intersectItemInfo = PinDialogUtil.getCurrentItem(intersectItem?.uid);
          const iteminfo = intersectItemInfo instanceof MonicaObject ? intersectItemInfo.itemInfo : intersectItemInfo?.parentObj?.itemInfo;

          if( pin[i].itemInfo.auxiliaryData.auxiliaryDatum.room_name == null) {
            pin[i].itemInfo.auxiliaryData.auxiliaryDatum.room_name = pin[i].itemInfo?.intersectItem ? PinDialogUtil.getItemRoomName(iteminfo, intersectItem, pin[i].itemInfo) : null;
          }
          if( pin[i].itemInfo.auxiliaryData.auxiliaryDatum.room_name == null || pin[i].itemInfo.auxiliaryData.auxiliaryDatum.room_name == '' ) pin[i].itemInfo.auxiliaryData.auxiliaryDatum.room_name = AuxiliaryUtil.ROOM_NAME_WHOLE;
          target.auxiliaryDatum.room_name = pin[i].itemInfo.auxiliaryData.auxiliaryDatum.room_name;

          retData.room_name = target.auxiliaryDatum.room_name;
          retList.push(retData);
        }
      }
    }
    return retList;
  }

  /**
   * 付帯工事1件を、自身(ピン)のguid指定で取得する
   * 紐づけアイテムが削除された(intersectItemがない)付帯工事は
   * getAuxiliaryListForQuoteById(intersectItem.uid基準)では取得できないため、
   * こちらを使う
   * @param guid 付帯工事(ピン)自身のguid
   */
  public static getAuxiliaryByGuid(guid: string): AuxiliaryConstructionCollection[] {
    const retList: AuxiliaryConstructionCollection[] = AuxiliaryUtil.getAuxiliaryList().filter((data) => data.guid === guid);
    retList.forEach((data) => {
      if (data.room_name == null || data.room_name === '') data.room_name = '全体';
      // JSON出力(見積JSON)で使うため、循環参照を持つピン本体(FreeText/SVGSprite等)への参照は保持しない
      data.parentPin = null;
    });
    return retList;
  }

  /**
   * 付帯工事一覧の取得
   * @param uuid
   */
  static hasAuxiliaryWithCheckOn(uuid: string): boolean {
    let auxList: AuxiliaryConstructionCollection[] = AuxiliaryUtil.getAuxiliaryListForQuoteById(uuid);
    if (auxList.length < 1) return false;

    let hasData: boolean = false;

    for (let i: number = 0; i < auxList.length; i++) {
      if (auxList[i].estimatedEntryFlg == 1) {
        hasData = true;
      }
    }
    return hasData;
  }
}
